import { render } from "./App.vue?vue&type=template&id=0a8806d4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0a8806d4&lang=css"

import exportComponent from "/Users/dlhaibin/WebVue/zhishujizhang_web官网/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__